import { render } from "./offerDetail.vue?vue&type=template&id=48761e3e&scoped=true"
import script from "./offerDetail.vue?vue&type=script&lang=js"
export * from "./offerDetail.vue?vue&type=script&lang=js"

import "./offerDetail.vue?vue&type=style&index=0&id=48761e3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48761e3e"]])

export default __exports__